module.exports = __webpack_public_path__ + "static/media/candidates.f5c48ef9.svg";